import { render, staticRenderFns } from "./changeName.vue?vue&type=template&id=942f5d4e&scoped=true&"
import script from "./changeName.vue?vue&type=script&lang=js&"
export * from "./changeName.vue?vue&type=script&lang=js&"
import style0 from "./changeName.vue?vue&type=style&index=0&id=942f5d4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "942f5d4e",
  null
  
)

export default component.exports